import styled from 'styled-components/macro';

export const CardLoaderWrapStyled = styled.div`
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
